import constants from '../secrets-web/src/config/constants';


const TIMEOUT_ACTION = {
  LOCK: 'lock',
  LOGOUT: 'logOut'
}

export default {
  ...constants,
  TIMEOUT_ACTION,
  SERVICE_SCOPE: 'secret',
  CLIENT_ID: 'web',
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  VAULT_TIMEOUTS: [
    {
      value: 1,
      label: 'timeouts.one_minute',
    },
    {
      value: 5,
      label: 'timeouts.five_minutes',
    },
    {
      value: 15,
      label: 'timeouts.fifteen_minutes',
    },
    {
      value: 30,
      label: 'timeouts.thirty_minutes',
    },
    {
      value: 60,
      label: 'timeouts.one_hour',
    },
    {
      value: 60 * 4,
      label: 'timeouts.four_hours',
    },
    {
      value: 60 * 24 * 14,
      label: 'timeouts.two_weeks',
    },
    {
      value: -1,
      label: 'timeouts.on_refresh',
    }
  ],
  VAULT_TIMEOUT_ACTIONS: [
    {
      value: TIMEOUT_ACTION.LOCK,
      label: 'button.lock',
    },
    {
      value: TIMEOUT_ACTION.LOGOUT,
      label: 'button.logout',
    },
  ],
};
